import Search from 'components/Search';
import React from 'react';

import './App.css';

function App() {
  return (
    <div className='App'>
      <Search />
    </div>
  );
}

export default App;
